// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app"


// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

// Initialize Firebase
const firebaseConfig = {
    apiKey: "AIzaSyDEv4ltP_-BlIRe21DmwkSNFOsXyBQBomA",
    authDomain: "mie-invoicer.firebaseapp.com",
    projectId: "mie-invoicer",
    storageBucket: "mie-invoicer.appspot.com",
    messagingSenderId: "3866187490",
    appId: "1:3866187490:web:fc1b4809cde73cc57cf0bb",
    measurementId: "G-8RZET99562"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);


export function ifLoggedIn(callback) {
    firebase.auth().onAuthStateChanged(user => {
        if (!user) {
            callback(false);
        } else {
            callback(true);
        }
    });
}


export function signIn(username, password, passCallback, errorCallback) {
    try {
        firebase
            .auth()
            .signInWithEmailAndPassword(username, password)
            .then(user => {
                passCallback(user);
            })
            .catch(error => {
                console.log(error.toString());
                errorCallback(error.toString());
            });
    } catch (error) {
        console.log(error.toString());
        return false;
    }
}

export function signOut(passCallback) {
    try {
        firebase
            .auth()
            .signOut()
            .then(() => {
                passCallback();
            });
    } catch (error) {
        console.log(error.toString());
    }
}

export function getCurrentlySignedInUser(setUser, noUser) {
    firebase.auth().onAuthStateChanged(user => {
        if (user) {
            setUser(user);
            //console.log("user signed in");
        } else {
            noUser();
            //console.log("no user logged in");
        }
    })
}

export function getUserProfile() {
    return firebase.firestore().collection("users");
}

export function createUser(username, password, passCallback, errorCallback) {
    try {

        firebase
            .auth()
            .createUserWithEmailAndPassword(username, password)
            .then(cred => {
                passCallback(cred);
            })
            .catch(error => {
                console.log(error.toString());
                errorCallback(error.toString());
            });
        return true;
    } catch (error) {
        console.log(error.toString());
        return false;
    }
}

export function createUserProfile(data, userID) {
    firebase
        .firestore()
        .collection("users")
        .doc(userID)
        .set({
            name: data.name,
            email: data.email,
            invoice_prefix: 'SVG-INV',
            invoice_index: 0,
            drafts: 0,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            submitted: 0
        });
}

export function addDocket(userID, data, passCallback, errorCallback) {
    const db = firebase.firestore();

    db.collection('dockets: ' + userID).add({
        ...data,
        timeStamp: firebase.firestore.FieldValue.serverTimestamp(),
    }).then(docRef => {
        passCallback();
    }).catch(error => {
        errorCallback(error.toString());
    });
}

export function addJob(userID, jobid, data, passCallback, errorCallback) {
    const db = firebase.firestore();

    db.collection('dockets: ' + userID).doc(jobid).collection('jobs: ' + jobid).add({
        quantity: data.quantity,
        desc: data.desc,
        unit: data.unit,
        amount: data.amount,
        createdAt: data.createdAt,
        timeStamp: firebase.firestore.FieldValue.serverTimestamp(),

    }).then(docRef => {
        passCallback();
    }).catch(error => {
        errorCallback(error.toString());
    });
}

export function incrementDocket(userID) {
    const increment = firebase.firestore.FieldValue.increment(1);

    const ref = firebase.firestore().collection('users').doc(userID);

    ref.update({ drafts: increment });
}

export function decrementDocket(userID) {
    const increment = firebase.firestore.FieldValue.increment(-1);

    const ref = firebase.firestore().collection('users').doc(userID);

    ref.update({ drafts: increment });
}

export function incrementSubmit(userID) {
    const increment = firebase.firestore.FieldValue.increment(1);

    const ref = firebase.firestore().collection('users').doc(userID);

    ref.update({ submitted: increment });
}

export function updateDocketInvoice(userID, docketID, invoice) {
    const ref = firebase.firestore().collection('dockets' + userID).doc(docketID);
    ref.update({ submitted: true, invoiceNumber: invoice });
}

export function getDockets(userID, passCallback, errorCallback) {
    const db = firebase.firestore();

    db.collection('dockets: ' + userID).orderBy('timeStamp').get().then(snapshot => {
        passCallback(snapshot);
    }).catch(error => {
        errorCallback(error.toString());
    })

}

export function getDocket(userID, docketID, passCallback, errorCallback) {
    const db = firebase.firestore();

    db.collection('dockets: ' + userID).doc(docketID).get().then(doc => {
        passCallback(doc);
    }).catch(error => {
        errorCallback(error.toString());
    })
}

export function stampToDate(timestamp) {
    return timestamp.toDate();
}

export function getDB() {
    return firebase.firestore();
}

export function getAuth() {
    return firebase.auth();
}